/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 1396
// module chunks = 0